import _ from 'lodash'

export const rowsPerPage = 25

export const statusColors = {
  uncontacted: '#5318E8',
  // sent: '#83E81A',
  // badLead: '#FF423A',
  spam: '#FF423A',
  duplicate: '#0EFFFA',
  // internalDuplicate: '#5DDFFF',
  working: '#FF37D5',
  invoiced: 'black',
  scheduled: 'rgb(83,165,81)',
  followUp: '#FFAC1C',
  contacted: '#478778',
  // realEstate: 'orange',
}

export const statusWithDarkFont = {
  sent: true,
  duplicate: true,
  internalDuplicate: true,
}

export const statusList = _(statusColors).keys().sortBy().value()

export const unassignedClientId = 'UNASSIGNED'

export const leadFields = [
  'name',
  'phoneNumber',
  'email',
  'date',
  'city',
  'status',
  'parseMapping',
]
